// services/api/index.js

import axios from "../axios/axiosInstance";
import ApiURL from "../ApiURL";
import { removeEmptyKeys } from "../../utils/removeEmptyKeys";

/**
 * Build the full API endpoint.
 */
const buildUrl = (key, id = null) => {
  const base = ApiURL[key];
  if (!base) throw new Error(`Missing API key: ${key}`);
  return id ? `${base}/${id}` : base;
};

/**
 * Format query params using URLSearchParams.
 */
const buildQuery = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, val]) => {
    if (Array.isArray(val)) {
      val.forEach((v) => query.append(key, v));
    } else {
      query.append(key, val);
    }
  });

  return query.toString() ? `?${query.toString()}` : "";
};

/**
 * Make the API call with error handling.
 */
const call = async ({ url, method, data, config = {} }) => {
  try {
    const response = await axios({ url, method, data, ...config });
    return response;
  } catch (error) {
    // optional: centralized logging here
    return Promise.reject(error);
  }
};

/**
 * GET
 */
export const apiGet = (key, queryParams = {}, id = null, config = {}) => {
  const params = removeEmptyKeys(queryParams);
  const url = `${buildUrl(key, id)}${buildQuery(params)}`;
  return call({ url, method: "GET", config });
};

/**
 * POST
 */
export const apiPost = (key, data = {}, id = null, config = {}) => {
  const url = buildUrl(key, id);
  let params = data;
  if (!(data instanceof FormData)) {
    params = removeEmptyKeys(data);
  }
  return call({ url, method: "POST", data: params, config });
};

/**
 * PUT
 */
export const apiPut = (key, id, data = {}, config = {}) => {
  const url = buildUrl(key, id);
  let params = data;
  if (!(data instanceof FormData)) {
    params = removeEmptyKeys(data);
  }

  return call({ url, method: "PUT", data: params, config });
};

/**
 * DELETE
 */
export const apiDelete = (key, id, data = {}, config = {}) => {
  const url = buildUrl(key, id);
  return call({ url, method: "DELETE", data, config });
};
